module.exports = __webpack_public_path__ + "img/header-hoteles-list-bg.1768042d.jpg";